import { render, staticRenderFns } from "./UpPortalDisplayImage.vue?vue&type=template&id=60c3c399&scoped=true&lang=pug"
import script from "./UpPortalDisplayImage.vue?vue&type=script&lang=js"
export * from "./UpPortalDisplayImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c3c399",
  null
  
)

export default component.exports